import { connect } from 'react-redux';
import { UpsellWidgetComponent } from '../../../../../partials/upsell-widget';
import { upsellWidgetDataSelector } from '../../../../../../redux/product/product.selectors';
import { upsellDismissProductBuilder } from '../../../../../../redux/product/product.actions';
const mapStateToProps = state => {
  const {
    newQuantity,
    newItemPrice,
    currentItemPrice,
    isWithinRange = false,
    showInWidget
  } = upsellWidgetDataSelector(state);
  return {
    isShown: showInWidget && isWithinRange,
    fromPricePerItem: currentItemPrice,
    toPricePerItem: newItemPrice,
    proposedQuantity: newQuantity || 0
  };
};
const mapDispatchToProps = dispatch => ({
  onUpsellDismiss: () => dispatch(upsellDismissProductBuilder())
});
export const UpsellWidget = connect(mapStateToProps, mapDispatchToProps)(UpsellWidgetComponent);